/**
 * Values stored on `Ccn.paymentMethod`. The entity declares the field as a
 * free-form string column; these are the only values used in practice
 * (legacy backoffice + new backoffice + Buchhaltungsbutler integration).
 */
export enum CcnPaymentMethod {
  PAYPAL = 'paypal',
  BANK_TRANSFER = 'bank transfer'
}

/**
 * Values stored on `Ccn.sepaType` (only meaningful when paymentMethod is
 * BANK_TRANSFER). Absence (null) signals a non-SEPA bank transfer.
 */
export enum CcnSepaType {
  EU_SEPA = 'EU_SEPA'
}
